module.exports = {
	init: function () {
		const headerBanner = document.querySelector('.header-banner');
		const headerBannerCloseBtn = headerBanner?.querySelector('.close-button');

		if (headerBanner) {
			headerBannerCloseBtn.addEventListener('click', () => {
				headerBanner.classList.add('hide');
				document.cookie = 'header-banner=closed';
			});
		}
	},
};
